import { actions } from 'actions';

/**
 * パンくずセットアクション
 * 
 * @param string text 表示メッセージ
 */
export const setBreadcrumb = (text, id = '') => {
  id = (id === '') ? text : id;
  return (dispatch) => {
    dispatch({
      type: actions.SET_BREADCRUMB,
      breadcrumb: text,
      id: id,
    });
  };
};

/**
 * パンくずクリアーアクション
 * 
 */
export const clearBreadcrumb = () => {
  return (dispatch) => {
    dispatch({
      type: actions.CLEAR_BREADCRUMB,
      breadcrumb: '',
      id: '',
    });
  };
};